import { classNames } from '@fullstory/util/fmt';
import React, { ReactElement } from 'react';
import { TextInputProps } from '../../components/TextInput';
import css from './index.module.scss';

export interface TextInputGroupProps {
  children: React.ReactElement<TextInputProps>[];
}

export const TextInputGroup: React.FC<TextInputGroupProps> = ({ children }) => (
  <>
    {React.Children.map(children, (child, i) => {
      const isFirst = i === 0;
      const isLast = i === children.length - 1;
      const textInput = child as ReactElement<{ className?: string }>;
      return React.cloneElement(textInput, {
        className: classNames(textInput.props.className, {
          [css.groupedInputTop]: isFirst,
          [css.groupedInputBottom]: isLast,
          [css.groupedInputMiddle]: !isFirst && !isLast,
        }),
      });
    })}
  </>
);
